import { Alert, Button, Chip, CircularProgress, Container, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { API_PERMISSION_URL, TICKET_SYSTEM_BASE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import ApiDialog from "./ApiDialog";
import { useAlert } from "../alerts/AlertContext";
import VisibilityIcon from "@mui/icons-material/Visibility";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function Apis() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getApiData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(API_PERMISSION_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching api data:", error);
      setError("Failed to load api data. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getApiData();
  }, [getApiData]);

  const openSwagger = (moduleId) => {

    // const configUrl = encodeURIComponent(`/api-docs/dynamic?moduleId=${moduleId}`);
    // window.open(`${TICKET_SYSTEM_BASE_URL}/swagger-ui/index.html?configUrl=${configUrl}`, "_blank");

    // sessionStorage.setItem("SWAGGER_MODULE_ID", moduleId);


    //commented below and taking form env
    // const swaggerUrl =
    //   `${TICKET_SYSTEM_BASE_URL}/swagger-ui/index.html` +
    //   `?configUrl=/api-docs/dynamic`;

    const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
    const swaggerUrl =
      `${baseUrl}/swagger-ui/index.html` +
      `?configUrl=/api-docs/dynamic`;

    window.open(swaggerUrl, "_blank");
  };

  const columns = [
    {
      field: "module",
      flex: 1,
      headerName: "Module",
      renderCell: (params) => params.value.name,
    },
    {
      field: "enable",
      flex: 1,
      headerName: "Enable",
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "startDate",
      flex: 1,
      headerName: "Start Date",
      renderCell: (params) => new Date(params.row?.startDate).toISOString().split("T")[0]
    },
    {
      field: "endDate",
      flex: 1,
      headerName: "End Date",
      renderCell: (params) => new Date(params.row?.endDate).toISOString().split("T")[0]
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <ApiDialog
            apiId={params.row.id}
            apiName="Edit"
            variant="link"
          />
        </Box>
      ),
    }
    // ,
    // {
    //   field: "view",
    //   flex: 1,
    //   headerName: "View",
    //   disableColumnMenu: true,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
    //       <IconButton
    //           color="primary"
    //           disabled={!params.row.enable}
    //           onClick={() => openSwagger(params.row.id)}
    //       >
    //         <VisibilityIcon />
    //      </IconButton>
    //      </Box>
    //   ),

    // }
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getApiData}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default Apis;
